import React, { useEffect, useState } from "react";

import Layout from "../components/Layout/Layout";
import TopAffiliates from "../components/TopAffiliates";
import ChapterBubbleChart from "../components/ChapterBubbleChart";
import UsersCard from "../components/UsersCard";
import PublishingSuccess from "../components/PublishingSuccess";
import ClicksConversion from "../components/ClicksConversion";
import API from "../services/api";

function Dashboard() {
  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await API.get(`admin/dashboard`);
      setDetails(response?.data?.data)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  };

 
  return (
    <Layout>
      <div className=" bg-gray-100">
        {
          !loading &&
        <div className="max-w-7xl mx-auto  min-h-screen pt-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
            <UsersCard details={details} />
            <PublishingSuccess details={details}/>
            <ClicksConversion details={details} />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <TopAffiliates details={details} />
            {
              // details?.most_used_chapters?.length &&
              <ChapterBubbleChart useddetails={ details} />
            }
          </div>
        </div>
        }
      </div>
    </Layout>
  );
}

export default Dashboard;
